import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { IconInfo } from 'svgIcons/MotionPortalIcons';
import { translate } from 'helpers/translateHelper';
import { getAssetIcon } from 'helpers/icons';
import { SearchBox } from 'sharedComponents/SearchBox';

const HierarchyPowertrainInfoModal = ({
    isOpen,
    onClose,
    selectedPowertrainInfo
}) => {

    const [searchboxFilter, setSearchboxFilter] = useState('');

    // Filter assets based on search box input
    const filteredAssets = selectedPowertrainInfo?.assets?.filter(asset => {
        if (!searchboxFilter.trim()) {
            return true;
        }

        const filterValue = searchboxFilter.toLowerCase();
        const assetName = String(asset.name || '').toLowerCase();
        const assetId = String(asset.id || '').toLowerCase();

        return assetName.includes(filterValue) ||
            assetId.includes(filterValue);
    }) || [];

    return (
        <GeneralDialog
            show={isOpen}
            close={onClose}
            title={
                <div className='hierarchy-powertrain-info-title'>
                    <IconInfo />
                    <span>{translate('ABB.Powertrain.Frontend.powertrainInfoModalTitle')} {selectedPowertrainInfo?.name} ({selectedPowertrainInfo?.assets?.length || 0})</span>
                </div>
            }
            modalClassName='hierarchy-powertrain-info-dialog'
            backdropClassName='hierarchy-powertrain-info-backdrop'
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.closeBtnLbl'),
                onClick: onClose
            }}
            closeButton={true}
        >
            <SearchBox
                onChange={setSearchboxFilter}
                value={searchboxFilter}
                placeholder={translate('ABB.Powertrain.Frontend.searchAssetByName')}
            />
            <div className={'asset-list'}>
                {filteredAssets.map(asset =>
                    <div key={asset.id} className='asset-list-item'>
                        <div className='asset-icon-container'>
                            {getAssetIcon(asset.assetType, { width: '16px', height: '16px' })}
                        </div>
                        <div className='asset-info'>
                            <div className='asset-name' title={asset.name}>
                                {asset.name}
                            </div>
                            <div className='asset-id'>
                                ({asset.id})
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </GeneralDialog>
    );
};

HierarchyPowertrainInfoModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    selectedPowertrainInfo: PropTypes.object
};

export default HierarchyPowertrainInfoModal;
